import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrDocumentUid = createSelector(
  [selectQbrState],
  ({ pptxReportState }) => pptxReportState.uid
)
